module.exports = __webpack_public_path__ + "img/SAFo_KeyTakeAways_ArtificialIntel.dfcd432d.png";